import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { IBaseProps } from '@rbi-ctg/frontend';
import Currency from 'components/currency';
import { usePaymentContext } from 'state/payment';
import { IPaymentMethod } from 'state/payment/types';

import { PrepaidBalance, PrepaidMethodType } from './styled';

const PrepaidBalanceStyled = styled(PrepaidBalance)`
  font-weight: ${Styles.fontWeight.heavy};
`;

interface IPrepaidMethodBalance extends IBaseProps {
  method: IPaymentMethod;
}

const PrepaidMethodBalance = ({ method }: IPrepaidMethodBalance) => {
  const { getBalanceFromPaymentMethods } = usePaymentContext();
  const { formatMessage } = useIntl();

  return (
    <PrepaidMethodType>
      <div>{formatMessage({ id: 'bk.payWithMyPrepaidCard' })}</div>
      <PrepaidBalanceStyled>
        <Currency amount={getBalanceFromPaymentMethods(method)} />
      </PrepaidBalanceStyled>
    </PrepaidMethodType>
  );
};

export default PrepaidMethodBalance;
